import type { MtoStockItem } from '@entities/mto';
import { fmtDate } from '@entities/mto';
import { isNegativeStock, qtyWithUnit, supplySource } from '../helpers';
import { Muted, Table, TableScroll, TrReview } from '../styles';

/**
 * Блок «Складские остатки» (модуль 2.4) — read-only таблица остатков. Неликвиды
 * (нет движения дольше горизонта) и отрицательные остатки приходят через общий
 * блок «Аномалии»; здесь дополнительно подсвечиваем строку с отрицательным
 * остатком (явная ошибка учёта). Остатки — строкой как есть.
 */
export function StockSection({ items }: { items: MtoStockItem[] }) {
  if (items.length === 0) {
    return <Muted>Остатки появятся после завершения обработки.</Muted>;
  }
  return (
    <TableScroll>
      <Table>
        <thead>
          <tr>
            <th scope="col">Наименование</th>
            <th scope="col" className="num">
              Остаток
            </th>
            <th scope="col">Склад</th>
            <th scope="col">Последнее движение</th>
            <th scope="col">Источник</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <TrReview key={it.id} $review={isNegativeStock(it.quantity)}>
              <td>{it.position_name}</td>
              <td className="num">{qtyWithUnit(it.quantity, it.unit)}</td>
              <td>{it.warehouse ?? '—'}</td>
              <td>{fmtDate(it.last_movement_date)}</td>
              <td>{supplySource(it.source_ref, it.source_file)}</td>
            </TrReview>
          ))}
        </tbody>
      </Table>
    </TableScroll>
  );
}
